// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-m_hj","advertDetailContactGroup__header":"c-m_hk","advertDetailContactGroup__value":"c-m_hl"};